import { render, staticRenderFns } from "./EmployeeFormListPage.vue?vue&type=template&id=5b2ba5d1&"
import script from "./EmployeeFormListPage.vue?vue&type=script&lang=ts&"
export * from "./EmployeeFormListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports